/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalCsmsEndpointDto
 */
export interface ExternalCsmsEndpointDto {
    /**
     * Stable endpoint id. Omit on create to let the server assign a UUID; include on update to preserve identity.
     * @type {string}
     * @memberof ExternalCsmsEndpointDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCsmsEndpointDto
     */
    role: ExternalCsmsEndpointDtoRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalCsmsEndpointDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExternalCsmsEndpointDto
     */
    baseUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCsmsEndpointDto
     */
    subprotocol?: ExternalCsmsEndpointDtoSubprotocolEnum;
    /**
     * 
     * @type {number}
     * @memberof ExternalCsmsEndpointDto
     */
    sortOrder?: number;
}


/**
 * @export
 */
export const ExternalCsmsEndpointDtoRoleEnum = {
    Primary: 'primary',
    Secondary: 'secondary'
} as const;
export type ExternalCsmsEndpointDtoRoleEnum = typeof ExternalCsmsEndpointDtoRoleEnum[keyof typeof ExternalCsmsEndpointDtoRoleEnum];

/**
 * @export
 */
export const ExternalCsmsEndpointDtoSubprotocolEnum = {
    Ocpp16: 'ocpp1.6',
    Ocpp201: 'ocpp2.0.1'
} as const;
export type ExternalCsmsEndpointDtoSubprotocolEnum = typeof ExternalCsmsEndpointDtoSubprotocolEnum[keyof typeof ExternalCsmsEndpointDtoSubprotocolEnum];


/**
 * Check if a given object implements the ExternalCsmsEndpointDto interface.
 */
export function instanceOfExternalCsmsEndpointDto(value: object): value is ExternalCsmsEndpointDto {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    return true;
}

export function ExternalCsmsEndpointDtoFromJSON(json: any): ExternalCsmsEndpointDto {
    return ExternalCsmsEndpointDtoFromJSONTyped(json, false);
}

export function ExternalCsmsEndpointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalCsmsEndpointDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'role': json['role'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'baseUrl': json['baseUrl'],
        'subprotocol': json['subprotocol'] == null ? undefined : json['subprotocol'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function ExternalCsmsEndpointDtoToJSON(json: any): ExternalCsmsEndpointDto {
    return ExternalCsmsEndpointDtoToJSONTyped(json, false);
}

export function ExternalCsmsEndpointDtoToJSONTyped(value?: ExternalCsmsEndpointDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'role': value['role'],
        'enabled': value['enabled'],
        'baseUrl': value['baseUrl'],
        'subprotocol': value['subprotocol'],
        'sortOrder': value['sortOrder'],
    };
}

